import React, { useState, useEffect } from "react";
import "./FatcaCRSDeclaration.modules.css";
import InvestmentBar from "./InvestmentBar/InvestmentBar";
import InvestmentFrequency from "./InvestmentFrequency/InvestmentFrequency";
import FinancialInstruments from "./FinancialInstruments/FinancialInstruments";
import { useTranslation } from "react-i18next";

const FatcaCRSDeclaration2 = (props) => {
  const { t } = useTranslation();
  const [RequestItemsList, setRequestItemsList] = useState([]);
  const [IsCallAPIOnce, setIsCallAPIOnce] = useState(false);

  useEffect(() => {
    ;
    if (IsCallAPIOnce) saveKycDataFun();
  }, [IsCallAPIOnce]);

  const saveKycDataFun = () => {
    ;
    props.saveKycDataAPI(RequestItemsList);
  };

  return (
    <div className="FatcaCRSDeclaration">
      <div className="form-container">
        <form className="dropdown-form">
          <div className="form-group">
            <h5> {t("previousTradingExperience")} </h5>

            <div className="seekbar-wrapper">
              <InvestmentBar title={t("InvestmentExperience")} setRequestItemsList={setRequestItemsList} IsCallAPI={props.IsCallAPI} setIsCallAPIOnce={setIsCallAPIOnce} setIsCallAPI={props.setIsCallAPI} RequestItemsList={RequestItemsList} />
            </div>
            <hr style={{ width: "80%", marginBottom: "0" }} />
          </div>
          <div className="form-group">
            <div className="seekbar-wrapper">
              <InvestmentFrequency setRequestItemsList={setRequestItemsList} IsCallAPI={props.IsCallAPI} setIsCallAPIOnce={setIsCallAPIOnce} setIsCallAPI={props.setIsCallAPI} RequestItemsList={RequestItemsList} />
            </div>
            <hr style={{ width: "80%", marginBottom: "0" }} />
          </div>

          <div className="form-group">
            <div className="seekbar-wrapper">
              <FinancialInstruments setRequestItemsList={setRequestItemsList} IsCallAPI={props.IsCallAPI} setIsCallAPIOnce={setIsCallAPIOnce} setIsCallAPI={props.setIsCallAPI} RequestItemsList={RequestItemsList} />
            </div>
          </div>
          {/* <button type="submit" className="submit-button">Submit</button> */}
        </form>
      </div>
    </div>
  );
};

export default FatcaCRSDeclaration2;
